import { memo } from "react";
import Skeleton from "react-loading-skeleton";

import classes from "./styles.module.css";
import { PRODUCT_SKELETON_COLOR } from "src/constants/colors";

const ProductSkeleton = () => {
    return (
        <div className={classes.product}>
            <div className={classes.card}>
                <div className={classes.img__con}>
                    <Skeleton height={300} baseColor={PRODUCT_SKELETON_COLOR} />
                </div>
                <div className={classes.content}>
                    <h4 className={classes.title}>
                        <Skeleton width={170} height={25} baseColor={PRODUCT_SKELETON_COLOR} />
                    </h4>
                    <div className={`my-1`}>
                        <Skeleton width={86} height={18} baseColor={PRODUCT_SKELETON_COLOR} />
                    </div>
                    <p className={classes.price}>
                        <span className={`${classes.original}`} >
                            <Skeleton width={120} height={22} className="mt-1" baseColor={PRODUCT_SKELETON_COLOR} />
                        </span>
                    </p>
                    <div>
                        <Skeleton height={36} baseColor={PRODUCT_SKELETON_COLOR} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default memo(ProductSkeleton);